export default __webpack_public_path__ + "static/media/1.329b403e.jpg";